// Mail-in tab — the same form in mail-in mode (address + prepaid label steps,
// $8 mail-back). Submits to the ship host via the BFF so the drop worker marks
// it order_type=mail-in.
import { DropForm } from "./DropForm";

export function MailIn() {
  return <DropForm formType="mail-in" />;
}
